import * as React from "react";
import { useApi } from "../../../../containers/ApiContainer";
import { useInterval } from "react-use";
import { FlightBridgeStatusPresenter } from "./FlightBridgeStatusPresenter";

// PostgREST result with joined fbo table
type IntegrationWithFbo = {
  fbo_id: string;
  external_company_id: string;
  airport_codes: string[];
  sync_status: string;
  last_sync_at: string;
  sync_error: string | null;
  fbo: { name: string } | null;
};

// Flattened type for presentation
export type FlightBridgeIntegration = {
  fbo_id: string;
  fbo_name: string;
  external_company_id: string;
  airport_codes: string[];
  sync_status: string;
  last_sync_at: string;
  sync_error: string | null;
};

export const FlightBridgeStatus: React.FC<{}> = () => {
  const { postgrest } = useApi();
  const [integrations, setIntegrations] = React.useState<FlightBridgeIntegration[]>([]);

  React.useEffect(() => {
    (async () => {
      const result = await postgrest
        .from("fbo_integration")
        .select("fbo_id, external_company_id, airport_codes, sync_status, last_sync_at, sync_error, fbo:fbo_id(name)")
        .eq("provider", "flightbridge")
        .eq("enabled", true);

      if (result.data) {
        // Flatten PostgREST join result
        const mapped = result.data.map((row: IntegrationWithFbo) => ({
          fbo_id: row.fbo_id,
          fbo_name: row.fbo?.name || 'Unknown FBO',
          external_company_id: row.external_company_id,
          airport_codes: row.airport_codes,
          sync_status: row.sync_status || 'pending',
          last_sync_at: row.last_sync_at,
          sync_error: row.sync_error,
        }));
        setIntegrations(mapped);
      }
    })();
  }, [postgrest]);

  // Auto-refresh every 10 seconds (like WorkerStatus)
  useInterval(async () => {
    const result = await postgrest
      .from("fbo_integration")
      .select("fbo_id, external_company_id, airport_codes, sync_status, last_sync_at, sync_error, fbo:fbo_id(name)")
      .eq("provider", "flightbridge")
      .eq("enabled", true);

    if (result.data) {
      const mapped = result.data.map((row: IntegrationWithFbo) => ({
        fbo_id: row.fbo_id,
        fbo_name: row.fbo?.name || 'Unknown FBO',
        external_company_id: row.external_company_id,
        airport_codes: row.airport_codes,
        sync_status: row.sync_status || 'pending',
        last_sync_at: row.last_sync_at,
        sync_error: row.sync_error,
      }));
      setIntegrations(mapped);
    }
  }, 10 * 1000);

  return <FlightBridgeStatusPresenter integrations={integrations} />;
};
